<template>
    <div class='realTime-wrap'>
        <p class="title">{{name}}(点击查看详细信息)</p>
        <div class="table">
            <div class="info" v-bind:style="{marginTop:isIEs?'14px':0}">
                <div class="info-item" v-for="(item,index) in realInfo" :key="index" @click="itemClick(index)">
                    <p class="info-item-title">
                        <span class="info-item-txt">{{item.label.substring(0,7)}}</span>
                        <span class="info-item-num">{{value(item.value)}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"RealTime",
    props:{
        name:{
            type:String,
            default:""
        },
        realInfo:{
            type:Array,
            default:[]
        },
        dialog:{
            type:Object,
            default:() => {}
        }
    },
    data(){
        return{
            isIEs:false
        }
    },
    methods: {
        itemClick(index){
            this.bus.$emit("itemClick",index);//发送信息
        },
         isIE(){
            if (!!window.ActiveXObject || "ActiveXObject" in window)
                return true;
            else
                return false;
          }
},
    computed: {
        value(){
            return (val) => {
                return isNaN(val) ? val : Number(val);
            }
        },
    },
    mounted(){
        if(this.isIE()){
            this.isIEs = true
        }
    },
    beforeDestroy() {
        this.bus.$off("itemClick");
    }
}
</script>

<style lang='scss' scoped>
    .realTime-wrap{
        width: 100%;height: 100%;overflow: hidden;border-radius:4px;position: relative;
        .title{
            font-weight: bold;color: #2e3842;height: 30px;line-height: 30px;background: #3f9efe;padding: 0px 10px;box-sizing: border-box;text-align: left;
        }
        .table{
            width: 100%;padding: 5px;box-sizing: border-box;position:absolute;bottom:0;top:30px;overflow:auto;
            .info{
                width: 100%;
                height:auto;
                flex-wrap: wrap;
                justify-content: space-around;
                margin-top: 6px;
                .info-item{
                    padding:4px 5px;
                    border:1px solid #409EFF;
                    border-radius:4px;
                    overflow:hidden;
                    float: left;
                    margin-right: 6px;
                    margin-bottom: 6px;
                    cursor: pointer;
                    width: calc(25% - 17px);
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    &:nth-child(4n){
                        margin-right: 0;
                    }
                    .info-item-title{
                        display: flex;align-items: center;
                        margin: 0;
                        .info-item-num{
                            font-weight: bold;flex:1;text-align: right;
                        }
                    }
                }
            }
        }
    }
</style>
